import Vue from 'vue'
import VueRouter from "vue-router";
import Empty from "@/views/Empty";
import Layout from "@/views/Layout";
import PERMISSION from '@/utils/permissions.js'
Vue.use(VueRouter)

// 注意：请尽量保持children数据中的name值是父级 name + '-' + childName

export const inLayoutRoute = [
  // {
  //   path: '/',
  //   name: 'home',
  //   meta:{
  //     title: '首页',
  //     icon: '',
  //   },
  //   component: () => import('../views/Home.vue'),
  // },
  {
    path: '/ebook',
    name: 'Ebook',
    isMenu: true,
    meta: {
      title: '电子书管理',
      icon: '',
      permission: PERMISSION.TEXTBOOK.RETRIEVE
    },
    component: Empty,
    children: [
      {
        path: '/ebook/list',
        name: 'EbookList',
        isMenu: true,
        meta: {
          title: '电子书列表',
          icon: '',
          permission: PERMISSION.TEXTBOOK.RETRIEVE
        },
        component: () => import('../views/ebook/List.vue'),
      },
    ]
  },
  {
    path: '/textbook',
    name: 'Textbook',
    isMenu: true,
    meta:{
      title: '数字教材管理',
      icon: '',
      permission: PERMISSION.TEXTBOOK.RETRIEVE
    },
    component: Empty,
    children: [
      {
        path: '/textbook/management',
        name: 'TextbookManagement',
        isMenu: true,
        meta: {
          title: '数字教材管理',
          icon: '',
          permission: PERMISSION.TEXTBOOK.RETRIEVE,
        },
        component: () => import('../views/textbook/management/Index.vue'),
      },
      {
        path: '/textbook/:id/edit',
        name: 'TextbookEdit',
        meta:{
          title: '教材编辑',
          icon: '',
        },
        component: () => import('../views/textbook/edit/index.vue'),
      },
      {
        path: '/textbook/:id/chapter',
        name: 'TextbookChapter',
        meta:{
          title: '教材详细',
          icon: '',
        },
        component: () => import('../views/textbook/chapter/index.vue'),
      },
      {
        path: '/textbook/list',
        name: 'TextbookList',
        isMenu: true,
        meta:{
          title: '教材制作审核',
          icon: '',
        },
        component: () => import('../views/textbook/list/index.vue'),
      },
      {
        path: '/textbook/:textbookId/:unitId/:lessonId/maker',
        name: 'TextbookMaker',
        meta:{
          title: '教材编辑',
          icon: '',
        },
        component: () => import('../views/textbook/maker/index.vue'),
      },
      {
        path: '/textbook/:textbookId/:unitId/:lessonId/:sectionId/ai_import',
        name: 'TextbookAIImport',
        meta:{
          title: '教材编辑',
          icon: '',
        },
        component: () => import('../views/textbook/edit/AIImport.vue'),
      },
      {
        path: '/textbook/static',
        name: 'TextbookStatic',
        isMenu: true,
        meta:{
          title: '教材统计',
          icon: '',
          permission: PERMISSION.TEXTBOOK.STAT,
        },
        component: () => import('../views/textbook/static/index.vue'),
      },
      {
        path: '/textbook/school_static',
        name: 'TextbookSchoolStatic',
        isMenu: true,
        meta:{
          title: '院校统计',
          icon: '',
          permission: PERMISSION.TEXTBOOK_CXJW_STAT.RETRIEVE,
        },
        component: () => import('../views/textbook/school_static/index.vue'),
      },
    ]
  },
  {
    path: '/redeem_code',
    name: 'RedeemCode',
    isMenu: true,
    meta:{
      title: '下载码管理',
      icon: '',
      permission: PERMISSION.REDEEM_CODE.RETRIEVE
    },
    component: Empty,
    children: [
      // {
      //   path: '/textbook/:id/edit',
      //   name: 'TextbookEdit',
      //   meta:{
      //     title: '教材编辑',
      //     icon: '',
      //   },
      //   component: () => import('../views/textbook/edit/index.vue'),
      // },
      {
        path: '/redeem_code/batch',
        name: 'RedeemCodeBatch',
        isMenu: true,
        meta:{
          title: '生成批次',
          icon: '',
          permission: PERMISSION.REDEEM_CODE.CREATE
        },
        component: () => import('../views/redeem_code/batch/index.vue'),
      },
    ]
  },
  {
    path: '/account',
    name: 'Account',
    isMenu: true,
    meta:{
      title: '账号管理',
      icon: '',
      permission: PERMISSION.ACCOUNT_MGT.RETRIEVE
    },
    component: Empty,
    children: [
      // {
      //   path: '/textbook/:id/edit',
      //   name: 'TextbookEdit',
      //   meta:{
      //     title: '教材编辑',
      //     icon: '',
      //   },
      //   component: () => import('../views/textbook/edit/index.vue'),
      // },
      {
        path: '/account/management',
        name: 'AccountManagement',
        isMenu: true,
        meta:{
          title: '账号管理',
          icon: '',
          permission: PERMISSION.ACCOUNT_MGT.RETRIEVE
        },
        component: () => import('../views/account/Account.vue'),
      },
      {
        path: '/account/daily-risk',
        name: 'DailyRiskAccount',
        isMenu: true,
        meta:{
          title: '每日风控账号',
          icon: '',
          permission: PERMISSION.ACCOUNT_MGT.RETRIEVE
        },
        component: () => import('../views/account/DailyRiskAccount.vue'),
      },
    ]
  },
  {
    path: '/news',
    name: 'News',
    isMenu: true,
    meta:{
      title: '资讯管理',
      icon: '',
      permission: PERMISSION.NEWS.RETRIEVE
    },
    component: Empty,
    children: [
      {
        path: '/news/management',
        name: 'NewsManagement',
        isMenu: true,
        meta:{
          title: '出版社资讯管理',
          icon: '',
          permission: PERMISSION.NEWS.RETRIEVE
        },
        component: () => import('../views/news/News.vue'),
      },
      {
        path: '/news/editor',
        name: 'NewsEditor',
        isMenu: false,
        meta:{
          title: '资讯编辑器',
          icon: '',
          permission: PERMISSION.NEWS.UPDATE
        },
        component: () => import('../views/news/NewsEditor.vue'),
      },
    ]
  },
  {
    path: '/column',
    name: 'Column',
    isMenu: true,
    meta: {
      title: '专栏管理',
      icon: '',
      permission: PERMISSION.COLUMN.RETRIEVE
    },
    component: Empty,
    children: [
      {
        path: '/column/classroom',
        name: 'ColumnClassroom',
        isMenu: true,
        meta: {
          title: '数字课堂',
          icon: '',
          permission: PERMISSION.COLUMN.RETRIEVE
        },
        component: () => import('../views/column/ColumnList.vue'),
      },
      {
        path: '/column/resource',
        name: 'ColumnResource',
        isMenu: true,
        meta: {
          title: '数字资源',
          icon: '',
          permission: PERMISSION.COLUMN.RETRIEVE
        },
        component: () => import('../views/column/ColumnList.vue'),
      },
      {
        path: '/column/knowledge',
        name: 'ColumnKnowledge',
        isMenu: true,
        meta: {
          title: '知识服务',
          icon: '',
          permission: PERMISSION.COLUMN.RETRIEVE
        },
        component: () => import('../views/column/ColumnList.vue'),
      },
      {
        path: '/column/editor',
        name: 'ColumnEditor',
        isMenu: false,
        meta: {
          title: '专栏编辑',
          icon: '',
          permission: PERMISSION.COLUMN.UPDATE
        },
        component: () => import('../views/column/ColumnEditor.vue'),
      },
    ]
  },
  {
    path: '/setting',
    name: 'Setting',
    isMenu: true,
    meta: {
      title: '系统设置',
      icon: '',
      permission: PERMISSION.TEXTBOOK.RETRIEVE
    },
    component: Empty,
    children: [
      {
        path: '/setting/category',
        name: 'SettingCategory',
        isMenu: true,
        meta: {
          title: '教材分类',
          icon: '',
          permission: PERMISSION.TEXTBOOK.RETRIEVE
        },
        component: () => import('../views/setting/category/index.vue'),
      },
      {
        path: '/setting/tag',
        name: 'SettingTag',
        isMenu: true,
        meta: {
          title: '教材标签',
          icon: '',
          permission: PERMISSION.TEXTBOOK.RETRIEVE
        },
        component: () => import('../views/setting/tag/index.vue'),
      },
      {
        path: '/setting/role',
        name: 'SettingRole',
        isMenu: true,
        meta: {
          title: '角色管理',
          icon: '',
          permission: PERMISSION.ROLE.RETRIEVE
        },
        component: () => import('../views/role/List.vue'),
      },
    ]
  }
]

export const withOutRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'layout',
    component: Layout,
    children: [
      ...inLayoutRoute,
    ]
  },
  {
    path: '/textbook/bookdetailcheck/:textbookId/:unitId/:filePath/:lessonId/:title',
    name: 'BookDetailCheck',
    meta:{
      title: '教材审核',
      icon: '',
    },
    component: () => import('../views/textbook/edit/BookDetailCheck.vue'),
  },
  {
    path: '/textbook/reader/:textbookId/:unitId/:filePath/:lessonId/:title',
    name: 'bookdetail',
    meta:{
      title: '教材预览',
      icon: '',
    },
    component: () => import('../views/textbook/reader/BookDetail.vue'),
  },
  {
    path: '/htmlReading/:textbookId/:unitId/:lessonId/:filePath/:title',
    name: 'htmlReading',
    meta:{
      title: '扩展阅读预览',
      icon: '',
    },
    component: () => import('../views/textbook/reader/HtmlReading.vue'),
  },
  {
    path: '/drill/practice/:id',
    name: 'Practice',
    meta:{
      title: '试题预览',
      icon: '',
    },
    component: () => import('../views/textbook/reader/PracticeView.vue'),
  },
  {
    path: '/reader/:textbookId',
    name: 'reader',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/textbook/reader2/Reader.vue'),
  },
  {
    path: '/reader/:textbookId/:unitId',
    name: 'reader_1',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/textbook/reader2/Reader.vue'),
  },
  {
    path: '/reader/:textbookId/:unitId/:lessonId',
    name: 'reader_2',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/textbook/reader2/Reader.vue'),
  },
  {
    path: '/:textbookId/:unitId/:lessonId',
    name: 'reader_4',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/textbook/reader2/Reader.vue'),
  },
  {
    path: '/reader/*',
    name: 'reader_3',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/textbook/reader2/Reader.vue'),
  }
]

export const routes = [...withOutRoutes]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
